import ChatRoom from './ChatRoom';

export default ChatRoom;

